import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  useTheme,
  Radio,
  RadioGroup,
} from "@mui/material";

export default function CategoryBrandMenu({
  section = { categories: [] },
  products = [],
  selectedCategory,
  selectedBrand,
  setSelectedCategory,
  setSelectedBrand,
}) {
  const theme = useTheme();
  const [uniqueBrands, setUniqueBrands] = useState([]);

  useEffect(() => {
    if (products?.length) {
      const brands = Array.from(
        new Set(products.map((p) => p.brand).filter(Boolean))
      );
      setUniqueBrands(brands);
    } else {
      setUniqueBrands([]);
    }
  }, [products]);

  const handleCategorySelect = (cat) => {
    setSelectedCategory(cat);
    setSelectedBrand([]);
  };

  const handleBrandToggle = (brand) => {
    const current = selectedBrand || [];
    setSelectedBrand(
      current.includes(brand)
        ? current.filter((b) => b !== brand)
        : [...current, brand]
    );
  };

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.grey[800]}`,
        borderRadius: 2,
        px: 2,
        py: 2,
        minWidth: 240,
      }}
    >
      <Typography
        sx={{
          fontWeight: "bold",
          fontSize: "0.95rem",
          color: theme.palette.text.primary,
          mb: 2,
        }}
      >
        FILTROS
      </Typography>

      <Typography
        sx={{
          fontWeight: "bold",
          fontSize: "0.85rem",
          color: theme.palette.text.primary,
          mb: 1,
        }}
      >
        Categorías
      </Typography>

      <RadioGroup
        value={selectedCategory?.id || ""}
        sx={{ mb: 3 }}
      >
        {section.categories.map((cat) => (
          <FormControlLabel
            key={cat.id}
            value={cat.id}
            control={
              <Radio
                size="small"
                onChange={() => handleCategorySelect(cat)}
                sx={{
                  color: theme.palette.grey[800],
                  "&.Mui-checked": { color: theme.palette.grey[800] },
                }}
              />
            }
            label={
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: "0.85rem",
                  color: theme.palette.text.primary,
                }}
              >
                {cat.name}
              </Typography>
            }
            sx={{ mb: 0.5 }}
          />
        ))}
      </RadioGroup>

      <Typography
        sx={{
          fontWeight: "bold",
          fontSize: "0.85rem",
          color: theme.palette.text.primary,
          mb: 1,
        }}
      >
        Marcas disponibles
      </Typography>

      {uniqueBrands.length > 0 ? (
        uniqueBrands.map((brand, idx) => (
          <FormControlLabel
            key={idx}
            control={
              <Checkbox
                size="small"
                checked={selectedBrand?.includes(brand)}
                onChange={() => handleBrandToggle(brand)}
                sx={{
                  backgroundColor: theme.palette.common.white,
                  borderRadius: 1,
                  "& .MuiSvgIcon-root": {
                    color: theme.palette.text.disabled,
                  },
                  "&.Mui-checked .MuiSvgIcon-root": {
                    color: theme.palette.grey[800],
                  },
                }}
              />
            }
            label={
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: "0.85rem",
                  color: theme.palette.text.primary,
                }}
              >
                {brand}
              </Typography>
            }
            sx={{ display: "flex", alignItems: "center", mb: 0.5 }}
          />
        ))
      ) : (
        <Typography
          sx={{
            fontSize: "0.8rem",
            color: theme.palette.text.secondary,
          }}
        >
          No hay marcas disponibles
        </Typography>
      )}
    </Box>
  );
}
